import { __decorate, __metadata } from "tslib";
import { DataFrame, SerializableObject, SerializableMember } from '@openhps/core';
import { ImageFrame } from './ImageFrame';
let StereoImageFrame = class StereoImageFrame extends DataFrame {
    /**
     * Source object clone that captured the data frame
     * @returns {StereoCameraObject} Source data object
     */
    get source() {
        return super.source;
    }
    /**
     * Set the source object clone that captured the data frame
     * @param {StereoCameraObject} object Source data object
     */
    set source(object) {
        super.source = object;
    }
};
__decorate([
    SerializableMember(),
    __metadata("design:type", ImageFrame)
], StereoImageFrame.prototype, "left", void 0);
__decorate([
    SerializableMember(),
    __metadata("design:type", ImageFrame)
], StereoImageFrame.prototype, "right", void 0);
StereoImageFrame = __decorate([
    SerializableObject()
], StereoImageFrame);
export { StereoImageFrame };
//# sourceMappingURL=StereoImageFrame.js.map